import {
  SaModalNameEnum,
  SaModalState,
} from '../../Administrator/ServiceAccount/types';
import { memo } from 'react';
import TeamsChatUpdateSecretOrChangeAppModal from '../../Administrator/ServiceAccount/TeamsChatModal';
const TeamsChatModal = memo(
  ({
    saModalState,
    onClose,
    refreshData,
  }: {
    saModalState: SaModalState;
    onClose: () => void;
    refreshData: () => void;
  }) => {
    if (
      !saModalState ||
      saModalState.name !== SaModalNameEnum.UpdateSecretOrChangeApp
    ) {
      return <></>;
    }
    const { data } = saModalState;
    return (
      <TeamsChatUpdateSecretOrChangeAppModal
        orgId={data.orgId}
        appId={data.appId}
        onClose={() => {
          onClose();
          refreshData();
        }}
      />
    );
  }
);

export default TeamsChatModal;
